import { all, takeLatest, fork, call, put } from "redux-saga/effects";
import actions from "./actions";
import { crawlDomesticIndicatorService} from "@iso/services";
export function* crawlDomesticIndicator() {
    yield takeLatest(actions.CRAWL_DOMESTIC_INDICATOR_REQUEST, function* ({ payload }) {
        const {
            periodStart,
            periodEnd,
            aggregationDate,
            googleSheetUrl,
            otas,
            resolve,
            reject
        } = payload;
        try {
            const response = yield call(crawlDomesticIndicatorService.crawlDomesticIndicator, {
                periodStart,
                periodEnd,
                aggregationDate,
                googleSheetUrl,
                otas,
                resolve,
                reject
            });
            yield put({
                type: actions.CRAWL_DOMESTIC_INDICATOR_SUCCESS,
                crawler: response,
            });
            yield resolve(response);
        } catch (e) {
            yield put({ type: actions.CRAWL_DOMESTIC_INDICATOR_ERROR });
            reject(e);
        }
    });
}

export function* getCrawlDomesticIndicator() {
    yield takeLatest(actions.GET_CRAWL_DOMESTIC_INDICATOR_REQUEST, function* () {
        try {
            const report = yield call(crawlDomesticIndicatorService.getCrawlDomesticIndicator);
            yield put({
                type: actions.GET_CRAWL_DOMESTIC_INDICATOR_SUCCESS,
                crawler: report,
            });
        } catch (error) {
            yield put({
                type: actions.GET_CRAWL_DOMESTIC_INDICATOR_ERROR,
                error: error.response,
            });
        }
    });
}
export function* deleteInformationStore() {
    yield takeLatest(actions.DELETE_EXCEL_STORE_DOMESTIC_INDICATOR_REQUEST, function* ({ payload }) {
        const {
            resolve,
            reject
        } = payload;
        try {
            const response = yield call(crawlDomesticIndicatorService.deleteInformationStore);
            yield put({
                type: actions.DELETE_EXCEL_DOMESTIC_INDICATOR_SUCCESS,
            });
            yield resolve(response);
        } catch (error) {
            yield put({
                type: actions.DELETE_EXCEL_DOMESTIC_INDICATOR_ERROR,
            });
            reject(error);
        }
    });
}
export function* getInformationStore() {
    yield takeLatest(actions.GET_EXCEL_DOMESTIC_INDICATOR_REQUEST, function* () {
        try {
            const response = yield call(crawlDomesticIndicatorService.getInformationStore);
            yield put({
                type: actions.GET_EXCEL_DOMESTIC_INDICATOR_SUCCESS,
                isExistFile: response,
            });
        } catch (error) {
            yield put({
                type: actions.GET_EXCEL_DOMESTIC_INDICATOR_ERROR,
                isExistFile: false,
            });
        }
    });
}

export function* updateFormula() {
    yield takeLatest(actions.UPDATE_FORMULA_DOMESTIC_INDICATOR_REQUEST, function* ({ payload }) {
        const {
            aggregationDate,
            googleSheetUrl,
            resolve,
            reject
        } = payload;
        try {
            const response = yield call(crawlDomesticIndicatorService.updateFormula, {
                aggregationDate,
                googleSheetUrl,
                resolve,
                reject
            });
            yield put({
                type: actions.UPDATE_FORMULA_DOMESTIC_INDICATOR_SUCCESS,
                crawler: response,
            });
            yield resolve(response);
        } catch (e) {
            yield put({ type: actions.UPDATE_FORMULA_DOMESTIC_INDICATOR_ERROR });
            reject(e);
        }
    });
}

export default function* rootSaga() {
    yield all([fork(crawlDomesticIndicator)]);
    yield all([fork(getCrawlDomesticIndicator)]);
    yield all([fork(deleteInformationStore)]);
    yield all([fork(getInformationStore)]);
    yield all([fork(updateFormula)]);
}